import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "@data-phone/react-resource-server-auth";
import { isPossiblePhoneNumber } from "libphonenumber-js";
import qs from "qs";
import { phoneNumberFormatE164 } from "utils/phoneNumberFormatE164";
import { CallHistoryRecord } from "redux/slices/callHistory.slice";

export interface CallHistoryRequest {
  callUUID: string;
  callDirection: "inbound" | "outbound";
  callerIDNumber: string;
  destination: string;
}

export interface CallHistoryItem {
  id: string; 
  direction: "inbound" | "outbound";
  records: CallHistoryRecord[];
}

export const fetchCallHistoryLookup = createAsyncThunk(
  "items/fetchCallHistory",
  async (data: CallHistoryRequest) => {
    const rawOthernum = data.callDirection === "inbound" ? data.callerIDNumber : data.destination;
const rawOurnum = data.callDirection === "inbound" ? data.destination : data.callerIDNumber;

const cleanedOthernum = rawOthernum?.trim().replace(/\s+/g, '');
const cleanedOurnum = rawOurnum?.trim();

const othernum = phoneNumberFormatE164(cleanedOthernum) ?? cleanedOthernum;



    if (!othernum || !isPossiblePhoneNumber(othernum, "US")) {
      return;
    }

    const query = qs.stringify(
  {
    filters: {
      othernum: othernum,
      limit: 5,
      offset: 0,
    },
  },
  { encode: false }
);

    const response = await api.get(`${process.env.REACT_APP_CDR_BASE_API_URL}/cdr?${query}`);

    return {
      records: response.data.records,
      direction: data.callDirection,
      id: data.callUUID,
    };
  }
);
